module.exports = __webpack_public_path__ + "media/images/color_admin_v3/login-bg/bg-6-98b12d145e9f982586ffdd0da461fa93.jpg";